import { render } from "./CardWallet.vue?vue&type=template&id=1d580e24&scoped=true"
import script from "./CardWallet.vue?vue&type=script&lang=js"
export * from "./CardWallet.vue?vue&type=script&lang=js"

import "./CardWallet.vue?vue&type=style&index=0&id=1d580e24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d580e24"]])

export default __exports__